import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-29">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="p-10 md:p-12 rounded-3xl border-2 border-black bg-white text-center" data-id="element-30">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-black text-white mb-6" data-id="element-31">
          <ShieldCheckIcon className="w-8 h-8" data-id="element-32" />
        </div>
        <h2 className="text-2xl md:text-3xl font-extrabold text-black mb-4 tracking-tight" data-id="element-33">
          PRUÉBALO SIN RIESGO.
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-34">
          Si lees los scripts y no sientes que tienes herramientas reales para
          tu próxima reunión, envíame un correo en los primeros 7 días y te
          devuelvo el importe íntegro. Estamos en fase de testeo y solo busco
          resultados reales.
        </p>
      </motion.div>
    </section>;
}